import {testIdProps} from '@github-ui/test-id-props'

import type {HeaderGroup} from '../../../hooks/tanstack-table/types'
import {AddColumnHeader} from '../add-column-header'
import {AddColumnId} from '../column-ids'
import {getHeaderCellPropsFromColumn} from '../get-cell-styles'
import {useGetDraggableHeaderProps} from '../state-providers/table-columns/column-order-dnd-provider'
import type {TableDataType} from '../table-data-type'
import {columnHeaderTestId} from '../test-identifiers'
import styles from './dummy-table-header-cell.module.css'
import {HeaderGridCell} from './header-grid-cell'
import {HeaderGridCellLayout} from './header-grid-cell-layout'

export const DummyHeaderCell = (props: {header: HeaderGroup<TableDataType>; height: number}) => {
  const dragProps = useGetDraggableHeaderProps(props.header.id, props.header.canReorder)

  const headerProps = getHeaderCellPropsFromColumn({
    columnId: props.header.id,
    colSpan: props.header.totalVisibleHeaderCount,
  })

  if (props.header.id === AddColumnId) {
    // workaround to ensure add column is rendered like our other header cells
    return (
      <HeaderGridCell
        tabIndex={-1}
        {...headerProps}
        {...dragProps.listeners}
        {...testIdProps(columnHeaderTestId(props.header.id))}
        ref={dragProps.setNodeRef}
      >
        <HeaderGridCellLayout className={styles.HeaderGridCellLayout}>
          <AddColumnHeader />
        </HeaderGridCellLayout>
      </HeaderGridCell>
    )
  }

  // eslint-disable-next-line react-hooks/refs
  return <div {...headerProps} role="cell" {...dragProps.listeners} ref={dragProps.setNodeRef} />
}

try{ DummyHeaderCell.displayName ||= 'DummyHeaderCell' } catch {}